'use strict';

const FetchHandler = require('../../deal/frontend/FetchHandler');

const WishlistButton = {
  toggleWishlistButtonStyle() {
    this.$wishlistButton.classList.toggle('wishlisted');
    this.$wishlistButtonTextAdd.classList.toggle('hidden');
    this.$wishlistButtonTextRemove.classList.toggle('hidden');
  },

  onAddItemSuccess(response) {
    const addedItem = {
      dealId: this.data.dealUUID,
      itemId: response.itemId,
      listId: response.listId,
      optionId: this.data.selectedOptionUUID,
      removeItemUrl: `/deals/wishlists_proxy/remove/${response.listId}/${response.itemId}`,
    };

    this.data.items.push(addedItem);
    this.data.removeItemUrl = addedItem.removeItemUrl;
    this.toggleWishlistButtonStyle();
  },

  toggleErrorMessage(elemSelector, timeout = 3000, fadeTimeout = 450) {
    const elem = document.querySelector(elemSelector);

    if (elem) {
      elem.classList.remove('hidden');
      setTimeout(() => elem.classList.add('fade-in'), 50);
      setTimeout(() => elem.classList.remove('fade-in'), timeout);
      setTimeout(() => elem.classList.add('hidden'), timeout + fadeTimeout);
    }
  },

  addItemToWishlist() {
    this.$wishlistButton.setAttribute('disabled', 'disabled');
    this.addItemFromWishlistHandler = new FetchHandler({
      requestOpts: {
        body: {
          dealId: this.data.dealUUID,
          optionId: this.data.selectedOptionUUID || undefined,
          _csrf: this.data.csrf,
        },
        credentials: 'include',
        method: 'post',
      },
      successHandlers: data => {
        this.onAddItemSuccess(data);
      },
      errorHandlers: () => {
        this.toggleErrorMessage('.wishlist-add-error');
      },
      completeHandlers: () => {
        this.$wishlistButton.removeAttribute('disabled');
      },
    });

    this.addItemFromWishlistHandler.url = this.data.addItemUrl;
    this.addItemFromWishlistHandler.send();
  },

  removeItemFromWishlist() {
    this.$wishlistButton.setAttribute('disabled', 'disabled');
    this.removeItemFromWishlistHandler = new FetchHandler({
      requestOpts: {
        body: {
          _csrf: this.data.csrf,
        },
        credentials: 'include',
        method: 'post',
      },
      successHandlers: () => {
        this.toggleWishlistButtonStyle();
        this.data.items = this.data.items.filter(
          ({ optionId }) => optionId !== this.data.selectedOptionUUID
        );
      },
      errorHandlers: () => {
        this.toggleErrorMessage('.wishlist-remove-error');
      },
      completeHandlers: () => {
        this.$wishlistButton.removeAttribute('disabled');
        this.data.selectedOptionUUID = null;
      },
    });

    this.removeItemFromWishlistHandler.url = this.data.removeItemUrl;
    this.removeItemFromWishlistHandler.send();
  },

  wishlistButtonClicked() {
    if (this.$wishlistButton.classList.contains('wishlisted')) {
      return this.removeItemFromWishlist();
    } else {
      return this.addItemToWishlist();
    }
  },

  multiOptionBreakoutClicked(event) {
    const target = event.target;
    this.data.selectedOptionUUID = target.getAttribute('data-uuid');
    return this.updateWishlistedNotifier();
  },

  updateWishlistedNotifier() {
    this.$wishlistButton.classList.remove('wishlisted');
    this.$wishlistButtonTextAdd.classList.remove('hidden');
    this.$wishlistButtonTextRemove.classList.add('hidden');

    const currentItem = this.data.items.find(
      ({ optionId }) => optionId === this.data.selectedOptionUUID
    );

    if (currentItem) {
      this.$wishlistButton.classList.add('wishlisted');
      this.$wishlistButtonTextAdd.classList.add('hidden');
      this.$wishlistButtonTextRemove.classList.remove('hidden');
      this.data.removeItemUrl = currentItem.removeItemUrl;
    }

    return currentItem;
  },

  listenToOptionSelection() {
    window.DealEventPipe.on(
      'priceUpdate',
      ({ variationsSelected, uuid } = {}) => {
        const $tooltip = document.querySelector('#select-option-tooltip');
        if (window.GIG && window.GIG.Tooltip) {
          window.GIG.Tooltip.close($tooltip);
        }
        this.data.selectedOptionUUID = variationsSelected ? uuid : null;
        return this.updateWishlistedNotifier();
      }
    );
  },

  init({ csrf, wishlist }, done) {
    this.$wishlistButton = document.querySelector('.add-to-wishlist-btn');
    this.$wishlistButtonTextAdd = document.querySelector(
      '.add-to-wishlist-btn-text-add'
    );
    this.$wishlistButtonTextRemove = document.querySelector(
      '.add-to-wishlist-btn-text-remove'
    );
    this.data = wishlist;
    this.data.csrf = csrf;
    this.data.selectedOptionUUID = this.data.selectedOptionUUID || null;

    this.listenToOptionSelection();

    if (this.$wishlistButton) {
      this.$wishlistButton.addEventListener(
        'click',
        this.wishlistButtonClicked.bind(this)
      );
    }

    document
      .querySelectorAll('.m-option-b input,.multi-option-overlay-list input')
      .forEach(el =>
        el.addEventListener('click', this.multiOptionBreakoutClicked.bind(this))
      );

    return done();
  },
};

module.exports = WishlistButton;
